/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { notificationModelSchema } from "../notificationModelSchema.ts";
import { z } from "zod";

export const getApiNotificationsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор push уведомления")
    })

/**
 * @description Модель уведомления
 */
export const getApiNotificationsId200Schema = z.lazy(() => notificationModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiNotificationsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiNotificationsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiNotificationsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Push уведомление не найдено
 */
export const getApiNotificationsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiNotificationsId500Schema = z.lazy(() => badResponseModelSchema)

export const getApiNotificationsIdQueryResponseSchema = z.lazy(() => getApiNotificationsId200Schema)